// code-reaper-ignore-file -- Uses different implementations for client and server.

import type {
	AnalyticsWebClient,
	InitAttrs,
} from '@jira/platform__observability-product-analytics-web-client-types';
import { getInitializedAnalyticsWebClient } from './getInitializedAnalyticsWebClient.tsx';
import { getServerAnalyticsWebClient } from './getServerAnalyticsWebClient.tsx';
import { initAnalyticsWebClient as browserInitAnalyticsWebClient } from './initAnalyticsWebClient.tsx';
import { initServerAnalyticsWebClient } from './initServerAnalyticsWebClient.tsx';

export const getAnalyticsWebClient = (attrs?: InitAttrs): AnalyticsWebClient => {
	return __SERVER__ ? getServerAnalyticsWebClient(attrs) : getInitializedAnalyticsWebClient();
};

export const initAnalyticsWebClient = (
	attrs?: InitAttrs,
): Promise<AnalyticsWebClient> | boolean | undefined => {
	// oxlint-disable-next-line typescript/no-non-null-assertion
	return __SERVER__ ? initServerAnalyticsWebClient(attrs) : browserInitAnalyticsWebClient(attrs!);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	ScreenEvent,
	UIEvent,
	TrackEvent,
	OperationalEvent,
	UnknownEvent,
	AnalyticsEvent,
} from '@jira/platform__observability-product-analytics-web-client-types';
